import axios from "axios";

const BASE_URL = process.env.REACT_APP_DEAL_AGENT_API_URL;

const dealsAgentApiUrl = `${BASE_URL}/deal/1.0`;

export const dealAgentApi = {
  askQuestion: async ( // sse stream the answer from the server
    payload: { question: string; session?: string; dealId?: string },
    onChunk: (event: any) => void
  ): Promise<void> => {
    const data: Record<string, unknown> = { // payload to send to the server
          'question': payload.question, 
          'deal_id': payload.dealId, 
          'session' : payload.session,  
    };

    const stream = await axios({
      method: "POST",
      url: `${dealsAgentApiUrl}/answer`,
      data,
      responseType: "stream",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
      },
      adapter: "fetch",
    }).then((r) => r.data);

    const reader = (stream as any) // get the reader from the stream
      .pipeThrough(new TextDecoderStream())
      .getReader();

    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += value;
      const lines = buffer.split("\n");
      buffer = lines.pop() ?? "";

      for (const line of lines) {
        if (line.startsWith("data:")) {
          const raw = line.substring(5).trim();
          if (raw) {
            try {
              onChunk(JSON.parse(raw));
            } catch { // ignore malformed SSE frames
             
            }
          }
        }
      }
    }
  },
};
